import React from "react";
import Routes from "./routes/routes";
import "./App.css";
import "./utils/var-styles.css";
import "./utils/animations/animations.css";

export default function App() {
    return <Routes />;
}
